import React, {useCallback} from 'react';
import Typography from '@material-ui/core/Typography';
import {TrackPopupProps} from './index';
import PopupCloseButton from '../PopupCloseButton';
import TrackStats from '../../TrackStats';

export default function NonWritableTrackPopup(props: TrackPopupProps) {

    const {tracks, onPopupChange, project, interaction} = props;
    const track = tracks[props.trackLocalId];
    const {notes, title, name, id} = track.properties;
    const pathname = `/datasummary/track/${id}/`;

    return <div style={{maxWidth: 250}}>
        <PopupCloseButton onClick={useCallback(() => onPopupChange(undefined), [onPopupChange])} />

        <Typography variant="body1" style={{fontWeight: 'bold'}} >
            <a rel="noopener noreferrer" href={pathname}>
                {title || name}
            </a>
        </Typography>

        <Typography variant="caption" style={{whiteSpace: 'pre-wrap'}}>{notes}</Typography>

        <TrackStats
            style={{flex: 1}}
            interaction={interaction}
            project={project}
            track={track}
        />
    </div>;
}
